/* Loading Configuratore — Paolina Roma (Dawn)
   L'overlay e' gia' visibile da HTML + CSS: questo script serve solo a
   nasconderlo, e a rimuoverlo dal DOM a transizione finita.
   - modalita "manual": timer fisso (durata dalla sezione).
   - modalita "automatic": evento reale CPB_ON_PRODUCT_MOUNTED dell'app CPB,
     piu' un MutationObserver su #product-builder e un timeout di sicurezza.
   Config letta da <script type="application/json" data-pr-loading-config>. */

(function () {
  'use strict';

  var DEFAULTS = {
    mode: 'manual',
    duration: 4000,
    minShow: 400,
    fadeOut: 400,
    maxWait: 8000
  };

  var MOUNT_EVENT = 'CPB_ON_PRODUCT_MOUNTED';
  var READY_SELECTOR = '.cpb-option, .cpb-category, .cpb-root';

  function readConfig(root) {
    var node = root.querySelector('[data-pr-loading-config]');
    var cfg = {
      mode: DEFAULTS.mode,
      duration: DEFAULTS.duration,
      minShow: DEFAULTS.minShow,
      fadeOut: DEFAULTS.fadeOut,
      maxWait: DEFAULTS.maxWait
    };

    if (!node) return cfg;

    try {
      var raw = JSON.parse(node.textContent);
      Object.keys(cfg).forEach(function (key) {
        if (raw[key] !== undefined && raw[key] !== null) cfg[key] = raw[key];
      });
    } catch (e) {
      /* config malformata: restano i default */
    }

    return cfg;
  }

  function init(root) {
    if (!root || root.dataset.prLoadingReady === '1') return;
    root.dataset.prLoadingReady = '1';

    var overlay = root.querySelector('[data-pr-loading-overlay]');
    if (!overlay) return;

    var cfg = readConfig(root);
    var startedAt = Date.now();
    var timers = [];
    var observer = null;
    var hidden = false;

    function cleanup() {
      timers.forEach(clearTimeout);
      timers = [];
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      document.body.removeEventListener(MOUNT_EVENT, hide);
    }

    function hide() {
      if (hidden) return;
      hidden = true;
      cleanup();

      var wait = Math.max(0, cfg.minShow - (Date.now() - startedAt));

      setTimeout(function () {
        overlay.classList.add('pr-hidden');
        setTimeout(function () {
          if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        }, cfg.fadeOut);
      }, wait);
    }

    if (cfg.mode === 'manual') {
      timers.push(setTimeout(hide, cfg.duration));
      return;
    }

    document.body.addEventListener(MOUNT_EVENT, hide);

    var builder = document.getElementById('product-builder');
    if (builder) {
      if (builder.querySelector(READY_SELECTOR)) {
        hide();
        return;
      }
      observer = new MutationObserver(function () {
        if (builder.querySelector(READY_SELECTOR)) hide();
      });
      observer.observe(builder, { childList: true, subtree: true });
    }

    timers.push(setTimeout(hide, cfg.maxWait));
  }

  function boot(scope) {
    var nodes = (scope || document).querySelectorAll('[data-pr-loading]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  /* Theme editor: la sezione viene re-iniettata senza rieseguire lo script. */
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
